//Api that return Lefebvre products by user navision
export const getProducts = async (userId, token) => {
  let url = `${window.API_GATEWAY}/api/v1/utilsauth/userutils/user/apps?idNavisionUser=${userId}`;
  if (window.currentUser && window.currentUser.env) {
    url += `&env=${window.currentUser.env}`;
  }

  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer " + token);
  const res = await fetch(url, { method: 'GET', headers: myHeaders });
  const products = await res.json();

  return products;
};

